import React, { useState, useEffect } from "react";
import Authentication from "../components/layouts/Authentication";
import ftcLogo from "../assets/images/ftc_logo.svg";
import { useNavigate } from "react-router-dom";
import { POST_VERIFY_OTP_URL, POST_RESEND_OTP_URL } from "../env";
import { Api, DeliveryDiningRounded, FloodTwoTone } from "@mui/icons-material";
import LoginForm from "../components/auth/LoginForm";
import ForgotPasswordForm from "../components/auth/LoginForm";
import VerifyOTPForm from "../components/auth/VerifyOtpForm";
import { ADMIN_LOGIN_URL } from "../env";
import { isSuccess } from "../helper/helper";
import { v4 as uuidv4 } from 'uuid';
import { getFullDeviceInfo } from "../utils/deviceInfo";
function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");

  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState();
  const [errorStar, setErrorStar] = useState();
  const [loading, setLoading] = useState(false);
  const [isSuccessLogin, setIsSuccessLogin] = useState(false);
  const [isEmailExits, setIsEmailExits] = useState(false);
  const [isForgetPassword, setIsForgetPassword] = useState(false);
  const [isOtpExpiryExists, setIsOtpExpiryExists] = useState("");
  const [isAlreadyHaveAccount, setIsAlreadyHaveAccount] = useState(false);
  const [isResend, setIsResend] = useState(false);
  const [otpCode, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(0);
  const [hideResendButton, setHideResendButton] = useState(false);
  // Device Login Management
  const [deviceId, setDeviceId] = useState('');
  const [deviceType, setDeviceType] = useState('');
  const [userAgent, setUserAgent] = useState('');
  const [ipAddress, setIpAddress] = useState('');


  useEffect(() => {
    (async () => {
      const { deviceId, deviceName, ipAddress } = await getFullDeviceInfo();
      setDeviceId(deviceId);
      setDeviceType(deviceName);
      setIpAddress(ipAddress);
    })();
  }, []);

  const startTimer = () => {
    if (isEmailExits && timer > 0) {
      const intervalId = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);

      return () => {
        clearInterval(intervalId);
      };
    } else {
      // Timer has ended, hide the "Resend" button
      setHideResendButton(true);
    }
  };

  useEffect(startTimer, [isEmailExits, timer]);

  const handleOtpChange = (newOtp) => {
    setOtp(newOtp);
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      setLoading(true); // Show loading overlay
      const response = await fetch(ADMIN_LOGIN_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: username,
          password: password,
          active: true,
          deviceId: deviceId,
          deviceName: deviceType + " " + userAgent,
          ipAddress: ipAddress,
        }),
      });
      const data = await response.json();
      // console.log("🚀 ~ handleLogin ~ data:", data?.data?.verification_code_expiry)
      if (data?.status === isSuccess) {
        setIsOtpExpiryExists(data?.data?.verification_code_expiry)
        // setIsOtpExpiryExists('2025-05-23T17:57:09.280Z')
        setLoading(false);
        setIsAlreadyHaveAccount(false);
        setIsForgetPassword(false);
        setIsResend(false);
        setIsEmailExits(true);
        setTimer(20);
        setHideResendButton(false);
      } else {
        setLoading(false); // Hide loading overlay on error
        setIsSuccessLogin(true);
        setErrorMessage(data?.message);
        setErrorStar("*");
      }
    } catch (error) {
      console.error("Login error:", error);
      // console.log("🚀 ~ handleLogin ~ data2222222222222:", data)
      setLoading(false); // Hide loading overlay on error
      setIsSuccessLogin(true);
      setErrorMessage("Incorrect Email or Password 2");
      setErrorStar("*");
    }
  };

  const verifyOtp = async (event) => {
    // debugger
    event.preventDefault();
    if (otpCode.join("").length === 6) {
      try {
        setLoading(true);
        const response = await fetch(POST_VERIFY_OTP_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: username,
            verification_code: otpCode.join(""),
            deviceId: deviceId,
            deviceName: deviceType + " " + userAgent,
            ipAddress: ipAddress,
          }),

        });

        const data = await response.json();
        if (data?.status === isSuccess) {
          // On successful login
          localStorage.setItem('staffRoles', JSON.stringify(data?.data?.staffRoles));
          localStorage.setItem('staffLevel', JSON.stringify(data?.data?.staffRoles[0]?.level));
          localStorage.setItem('staffPermissionName', JSON.stringify(data?.data?.staffRoles[0]?.permissionName));
          localStorage.setItem('userId', data?.data?._id);
          localStorage.setItem('token', data?.token); // Store JWT
          localStorage.setItem('userLoggedInDetails', JSON.stringify(data?.data));
          localStorage.setItem('loginDateTime', JSON.stringify(data?.data?.verification_code_expiry));
          setLoading(false);
          setIsAlreadyHaveAccount(false);
          setIsForgetPassword(false);
          setIsEmailExits(true);
          window.location.href = "/staff-overview";
          // navigate("/staff-overview");
        } else {
          setLoading(false);
          setIsSuccessLogin(false);
          setErrorStar("*");
        }
      } catch (error) {
        setLoading(false);
        console.error("OTP verification error:", error);
      }
    } else {
      alert("Please enter a valid 6-digit OTP.");
    }
  };


  const handleForgetPassword = (event) => {
    event.preventDefault();
    setIsForgetPassword(true);
    setIsEmailExits(false);
  };

  const handleAlreadyHaveAccount = (event) => {
    event.preventDefault();
    setIsForgetPassword(false);
    setIsAlreadyHaveAccount(true);
    setIsEmailExits(false);
  };

  const handleResendOTP = async (event) => {
    event.preventDefault();
    try {
      setLoading(true); // Show loading overlay
      const response = await fetch(POST_RESEND_OTP_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: username,
        }),
      });
      const data = await response.json();
      if (data?.status === isSuccess) {
        console.log("success", data)
        setIsOtpExpiryExists(data?.data?.verification_code_expiry)
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error("Login error:", error);
      setLoading(false); // Hide loading overlay on error
    }
    setTimer(20);
    setIsResend(true);
    setIsEmailExits(true);
  };


  // Device Login Management

  // useEffect(() => {
  //   const id = getDeviceId();
  //   const { deviceType, userAgent } = getDeviceInfo();
  //   setDeviceId(id);
  //   setDeviceType(deviceType);
  //   setUserAgent(userAgent);
  // }, []);

  // const getDeviceId = () => {
  //   let deviceId = localStorage.getItem('device_id');
  //   if (!deviceId) {
  //     deviceId = uuidv4(); // Use uuid instead of crypto.randomUUID()
  //     localStorage.setItem('device_id', deviceId);
  //   }
  //   return deviceId;
  // };

  // const getDeviceInfo = () => {
  //   const ua = navigator.userAgent;

  //   // Detect device type
  //   let deviceType = "Unknown";
  //   if (/mobile/i.test(ua)) {
  //     deviceType = "Mobile";
  //   } else if (/tablet/i.test(ua)) {
  //     deviceType = "Tablet";
  //   } else {
  //     deviceType = "Desktop";
  //   }

  //   // Detect browser
  //   let browser = "Unknown Browser";
  //   let browserVersion = "";
  //   if (/chrome|crios|crmo/i.test(ua)) {
  //     browser = "Chrome";
  //     browserVersion = ua.match(/(?:chrome|crios)\/([\d.]+)/i)?.[1] || "";
  //   } else if (/firefox|fxios/i.test(ua)) {
  //     browser = "Firefox";
  //     browserVersion = ua.match(/firefox\/([\d.]+)/i)?.[1] || "";
  //   } else if (/safari/i.test(ua) && !/chrome|crios|crmo/i.test(ua)) {
  //     browser = "Safari";
  //     browserVersion = ua.match(/version\/([\d.]+)/i)?.[1] || "";
  //   } else if (/edg/i.test(ua)) {
  //     browser = "Edge";
  //     browserVersion = ua.match(/edg\/([\d.]+)/i)?.[1] || "";
  //   }

  //   // Detect OS
  //   let os = "Unknown OS";
  //   if (/Windows NT 11.0/i.test(ua)) {
  //     os = "Windows 11";
  //   } else if (/Windows NT 10.0/i.test(ua)) {
  //     os = "Windows 10";
  //   } else if (/Windows NT 6.1/i.test(ua)) {
  //     os = "Windows 7";
  //   } else if (/Mac OS X (\d+[_\.]\d+)/i.test(ua)) {
  //     const version = ua.match(/Mac OS X (\d+[_\.]\d+)/i)?.[1].replace(/_/g, ".");
  //     os = `macOS ${version}`;
  //   } else if (/Android (\d+[\.\d]*)/i.test(ua)) {
  //     os = `Android ${ua.match(/Android (\d+[\.\d]*)/i)?.[1]}`;
  //   } else if (/iPhone OS (\d+[_\d]*)/i.test(ua)) {
  //     os = `iOS ${ua.match(/iPhone OS (\d+[_\d]*)/i)?.[1].replace(/_/g, ".")}`;
  //   }

  //   const userAgent = `${browser} ${browserVersion} on ${os}`;
  //   return { deviceType, userAgent };
  // };

  // useEffect(() => {
  //   fetch("https://api.ipify.org?format=json")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setIpAddress(data.ip);
  //     });
  // }, []);

  // console.log("deviceId:", deviceId)
  // console.log("deviceName", deviceType + " " + userAgent)
  // console.log("IP Address", ipAddress)

  return (

    <Authentication>
      {isEmailExits ? (
        <VerifyOTPForm
          ftcLogo={ftcLogo}
          otpCode={otpCode}
          errorStar={errorStar}
          handleOtpChange={handleOtpChange}
          handleResendOTP={handleResendOTP}
          timer={timer}
          isEmailExits={isEmailExits}
          isResend={isResend}
          handleVerifyOtp={verifyOtp}
          loading={loading}
          isOtpExpiryExists={isOtpExpiryExists}
          username={username}
        />
      ) : isForgetPassword ? (
        <ForgotPasswordForm
          ftcLogo={ftcLogo}
          handleAlreadyHaveAccount={handleAlreadyHaveAccount}
        />
      ) : isAlreadyHaveAccount ? (
        <LoginForm
          ftcLogo={ftcLogo}
          errorStar={errorStar}
          username={username}
          setUsername={setUsername}
          password={password}
          setPassword={setPassword}
          errorMessage={errorMessage}
          loading={loading}
          handleLogin={handleLogin}
        />
      ) : (
        <LoginForm
          ftcLogo={ftcLogo}
          errorStar={errorStar}
          username={username}
          setUsername={setUsername}
          password={password}
          setPassword={setPassword}
          errorMessage={errorMessage}
          loading={loading}
          handleLogin={handleLogin}
        />
      )}
    </Authentication>
  );
}

export default Login;
